export default "__VITE_ASSET__C4fHB1ux__"